import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';
import { translate } from '../i18n';
import { passwordChangeRequired } from '../utils/session';
import { CHANGE_PASSWORD_PATH } from '../utils/passwordPolicy';

/**
 * Alerte permanente tant que l'utilisateur garde le mot de passe reçu par email
 * (« You never changed your password » de schema-based-tenant-management) : ce mot de passe
 * a pu être intercepté, il doit être changé d'urgence.
 */
const PasswordChangeAlert = () => {
    const location = useLocation();
    const language = useSelector((state) => state.lang?.lang) || 'FR';
    // Le jeton Redux change à chaque connexion / changement de mot de passe ; localStorage fait foi après un rechargement.
    const token = useSelector((state) => state.auth?.token) || localStorage.getItem('token');
    if (!passwordChangeRequired(token) || location.pathname === CHANGE_PASSWORD_PATH) return null;
    const text = translate('password_change', language) || translate('password_change', 'FR');
    const returnTo = `${location.pathname}${location.search}`;
    return (
        <div className="password-change-alert" role="alert">
            <span aria-hidden="true">⚠️</span>
            <p>
                <strong>{text.alert_title}</strong> {text.alert_body}
            </p>
            <Link className="button password-change-alert__action" to={`${CHANGE_PASSWORD_PATH}?redirect=${encodeURIComponent(returnTo)}`}>
                {text.alert_action}
            </Link>
        </div>
    );
};

export default PasswordChangeAlert;
